import React from 'react';
import { useTheme, ITheme } from 'src/theme';
import { styled } from '@linaria/react';

const Container = styled.div<DividerProps>`
  height: 0px;
  border-top: ${props => `${props.variant} ${props.size}px ${props.color ? props.color : props.theme?.colors.grey[700]}`};
  margin: ${props => typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
`
export interface DividerProps {
  variant: 'solid' | 'dotted' | 'dashed';
  theme?: ITheme;
  margin: number | string;
  color?: string;
  size: number;

}

function Divider(props: DividerProps) {
  const theme = useTheme();
  return (
    <Container theme={theme} {...props}></Container>
  );
};

Divider.defaultProps = {
  margin: '0 0 15px',
  size: 1,
  variant: 'solid'
}

export default Divider;
